module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "student"
  }, [(_vm.student) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 col-md-6"
  }, [_c('h1', [_vm._v("\n                " + _vm._s(_vm.student.first) + " " + _vm._s(_vm.student.last) + " \n                ")]), _vm._v(" "), _c('h4', [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.student.email
    }
  }, [_vm._v(_vm._s(_vm.student.email))])]), _vm._v(" "), _c('h4', {
    staticClass: "galleries-link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'galleries',
        query: {
          author: _vm.userId
        }
      }
    }
  }, [_vm._v("Gallery Submissions")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 col-md-6 text-right"
  }, [_c('img', {
    attrs: {
      "src": _vm.student.avatar
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "panel status row"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        _vm.showStatus = !_vm.showStatus
      }
    }
  }, [_c('h2', [_vm._v("Status \n                    "), (_vm.showStatus) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showStatus && _vm.currentTerm) ? _c('div', [_c('student-admin-status', {
    attrs: {
      "userId": _vm.userId,
      "currentTerm": _vm.currentTerm
    }
  })], 1) : _vm._e()]), _vm._v(" "), (!_vm.localStorage.roles.includes('CampusDirector')) ? _c('div', [(!_vm.localStorage.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel videos row"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        _vm.showProgresses = !_vm.showProgresses
      }
    }
  }, [_c('h2', [_vm._v("Video Progress \n                        "), (_vm.showProgresses) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showProgresses) ? _c('ul', {
    staticClass: "list-group"
  }, _vm._l((_vm.videos), function(video) {
    return _c('li', {
      staticClass: "list-group-item"
    }, [_c('h3', [_vm._v(_vm._s(video.title))]), _vm._v(" "), _c('ul', {
      staticClass: "list-group row progresses"
    }, _vm._l((video.video_chapters), function(chapter) {
      return _c('li', {
        staticClass: "col-xs-12"
      }, [_c('div', {
        staticClass: "col-xs-4"
      }, [_c('h4', [_vm._v(_vm._s(chapter.title))])]), _vm._v(" "), _c('div', {
        staticClass: "progress-wrapper col-xs-8"
      }, [(chapter.progress) ? _c('span', {
        staticClass: "progress",
        style: ({
          width: _vm.progress(chapter) + '%'
        })
      }, [_vm._v(_vm._s(_vm.progress(chapter)) + "%")]) : _vm._e()])])
    }))])
  })) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localStorage.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel interactions row"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        _vm.showInteractions = !_vm.showInteractions
      }
    }
  }, [_c('h2', [_vm._v("Interactions\n                        "), (_vm.showInteractions) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showInteractions) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-lg-4 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.student.posts))]), _vm._v(" "), _c('h4', [_vm._v("Posts")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.student.chatMessages))]), _vm._v(" "), _c('h4', [_vm._v("Chat Messages")])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4 col-md-3 text-center"
  }, [_c('div', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.student.assignments.length))]), _vm._v(" "), _c('h4', [_vm._v("Hand-ins")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localStorage.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel assignments panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading exercises-header",
    on: {
      "click": function($event) {
        _vm.showExercises = !_vm.showExercises
      }
    }
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/exercise-icon.png")
    }
  }), _vm._v("Exercises\n                        "), (_vm.showExercises) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showExercises) ? _c('div', {
    staticClass: "panel-body nopad"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.student.handins), function(handin) {
    return _c('tr', {
      class: {
        'danger': handin.assessment == 1
      }
    }, [_c('td', [_vm._v(_vm._s(handin.exercise.associated.name))]), _vm._v(" "), _c('td', [(handin.exercise && handin.exercise.title) ? _c('span', [_vm._v(_vm._s(handin.exercise.title))]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(handin.week))]), _vm._v(" "), _c('td', [(handin.assessment) ? _c('span', [_vm._v(_vm._s(_vm.getAssessment(handin.assessment)))]) : _vm._e()]), _vm._v(" "), _c('td', [(handin.comments) ? _c('span', [_vm._v(_vm._s(handin.comments))]) : _vm._e()]), _vm._v(" "), _c('td', _vm._l((handin.url), function(file, $index) {
      return _c('div', [_c('a', {
        attrs: {
          "target": "_blank",
          "href": file
        }
      }, [_vm._v("File " + _vm._s($index + 1))])])
    })), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("longDate")(handin.createdAt)))])])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.localStorage.roles.includes('OnlineDirector')) ? _c('div', {
    staticClass: "panel assignments panel-primary"
  }, [_c('div', {
    staticClass: "panel-heading assignments-header",
    on: {
      "click": function($event) {
        _vm.showAssignments = !_vm.showAssignments
      }
    }
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments\n                        "), (_vm.showAssignments) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showAssignments) ? _c('div', {
    staticClass: "panel-body nopad"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.student.assignments), function(assignment) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(assignment['instance.associated.name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assignment['assignment.name']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assignment['assignment.week']))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("shortDate")(assignment.createdAt)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assignment.grade))]), _vm._v(" "), _c('td', [_c('a', {
      staticClass: "btn btn-sm btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openAssignment(assignment.url, assignment['assignment.name'])
        }
      }
    }, [_vm._v("Download")])])])
  }))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "panel evaluations row"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        _vm.showEvaluations = !_vm.showEvaluations
      }
    }
  }, [_c('h2', [_vm._v("Evaluations\n                            "), (_vm.showEvaluations) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showEvaluations) ? _c('div', {
    staticClass: "panel-body"
  }, _vm._l((_vm.evaluations), function(evaluation) {
    return _c('div', {
      staticClass: "col-sm-6"
    }, [_c('h4', [_vm._v(_vm._s(_vm._f("capitalize")(evaluation.term)))]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (evaluation.comments),
        expression: "evaluation.comments"
      }],
      staticClass: "form-control",
      attrs: {
        "rows": "5"
      },
      domProps: {
        "value": (evaluation.comments)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          evaluation.comments = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "form-group"
    }, [_c('button', {
      staticClass: "btn btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.saveEvaluation(evaluation)
        }
      }
    }, [_vm._v("Save")])])])
  })) : _vm._e()])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.canSeeFinalProjects) ? _c('div', {
    staticClass: "panel projects row"
  }, [_c('div', {
    staticClass: "panel-heading",
    on: {
      "click": function($event) {
        _vm.showProjects = !_vm.showProjects
      }
    }
  }, [_c('h2', [_vm._v("\n                    Final Projects\n                    "), (_vm.showProjects) ? _c('i', {
    staticClass: "fa fa-caret-down"
  }) : _c('i', {
    staticClass: "fa fa-caret-right"
  })])]), _vm._v(" "), (_vm.showProjects) ? _c('div', {
    staticClass: "project panel-body"
  }, [(_vm.student && _vm.student.final_projects) ? _c('ul', {
    staticClass: "projects"
  }, _vm._l((_vm.studentProjects), function(project, $index) {
    return _c('li', [_c('div', {
      staticClass: "table-row"
    }, [_c('div', [_c('i', {
      staticClass: "fa fa-plus",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.selectedProject === project.id ? _vm.selectedProject = null : _vm.selectedProject = project.id
        }
      }
    })]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._f("shortDate")(project.createdAt)) + " | " + _vm._s(_vm.getTermName(project.term)))]), _vm._v(" "), _c('div', _vm._l((project.final_feedbacks), function(final_feedback, $feedbackIndex) {
      return _c('div', [(final_feedback && final_feedback.url.trim() != '') ? _c('img', {
        staticClass: "play-button",
        attrs: {
          "src": require("../assets/img/play-button-small-green.png")
        },
        on: {
          "click": function($event) {
            _vm.playFeedback(final_feedback.url)
          }
        }
      }) : _c('span', [($feedbackIndex === 0) ? _c('img', {
        staticClass: "play-button",
        attrs: {
          "src": require("../assets/img/play-button-small-grey.png")
        }
      }) : _vm._e()])])
    })), _vm._v(" "), _c('div', {
      staticClass: "project-status",
      class: _vm.getStatus(project)
    }, [_vm._v("\n                                " + _vm._s(_vm._f("deslugify")(_vm.getStatus(project))) + "\n                            ")])]), _vm._v(" "), (_vm.selectedProject === project.id) ? _c('div', {
      staticClass: "project"
    }, [_c('div', {
      staticClass: "media"
    }, [_c('div', {
      staticClass: "project-images text-center"
    }, [_c('div', {
      staticClass: "reel text-center"
    }, [_c('video', {
      attrs: {
        "controls": ""
      }
    }, [_c('source', {
      attrs: {
        "src": project.demoReelUrl.replace('drive.google.com:', '')
      }
    })]), _vm._v(" "), _c('a', {
      attrs: {
        "href": project.demoReelUrl.replace('drive.google.com:', ''),
        "target": "_blank"
      }
    }, [_vm._v("\n                                            Download\n                                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "still-renders"
    }, [(project.stillRenders && project.stillRenders.length > 0) ? _c('ul', {
      staticClass: "still-renders"
    }, [_vm._l((project.stillRenders), function(render, $index) {
      return _c('li', [(render.includes('amazonaws')) ? _c('div', [_c('a', {
        attrs: {
          "href": render,
          "target": "_blank"
        }
      }, [_vm._v("\n                                                    Image " + _vm._s($index + 1) + "\n                                                ")])]) : _c('div', [_c('a', {
        staticClass: "possibly-broken-image",
        attrs: {
          "href": 'https://drive.google.com/uc?download=view&id=' + render.replace('drive.google.com:', ''),
          "target": "_blank"
        }
      }, [_vm._v("\n                                                    Image " + _vm._s($index + 1) + "\n                                                ")])])])
    }), _vm._v(" "), _vm._m(2, true), _vm._v(" "), (project.extraVideos.length === 0) ? _c('li', [_vm._v("No additional videos")]) : _vm._e(), _vm._v(" "), _vm._l((project.extraVideos), function(asset, $index) {
      return _c('li', [_c('a', {
        attrs: {
          "href": asset.url,
          "target": "_blank"
        }
      }, [_vm._v(_vm._s(asset.descriptor))])])
    })], 2) : _vm._e()])]), _vm._v(" "), (project.comments) ? _c('div', [_c('label', {
      staticClass: "comments"
    }, [_vm._v("Student Comments")]), _c('div', {
      staticClass: "comments",
      domProps: {
        "innerHTML": _vm._s(_vm.$options.filters.linkify(_vm.escapeHtml(project.comments)))
      }
    })]) : _vm._e(), _vm._v(" "), (project.passed === true && _vm.student.venue !== 'Campus') ? _c('div', {
      staticClass: "diploma"
    }, [_c('a', {
      attrs: {
        "href": 'https://ttto-graduation-certificates.s3.us-west-2.amazonaws.com/Think_Tank_Graduation_Certificate_' + _vm.student.populiId + '.pdf',
        "_target": "blank"
      }
    }, [_vm._v("\n                                    Digital Credentials\n                                ")])]) : _vm._e(), _vm._v(" "), _vm._l((project.final_feedbacks), function(final_feedback) {
      return _c('div', [(final_feedback.comments) ? _c('div', {
        staticClass: "director-comments"
      }, [_c('label', {
        staticClass: "comments"
      }, [_vm._v(_vm._s(final_feedback.author.firstName) + " " + _vm._s(final_feedback.author.lastName) + "'s Comments (" + _vm._s(_vm._f("checkinDate")(final_feedback.createdAt)) + ")")]), _vm._v(" "), (final_feedback.author.id == _vm.localStorage.user_id && _vm.isDirector) ? _c('button', {
        staticClass: "btn btn-xs delete",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.deleteFeedback(final_feedback.id)
          }
        }
      }, [_vm._v("Delete Comments and Video")]) : _vm._e(), _vm._v(" "), _c('div', {
        staticClass: "comments"
      }, [_vm._v(_vm._s(final_feedback.comments))])]) : _vm._e()])
    }), _vm._v(" "), _c('label', {
      staticClass: "comments"
    }, [_vm._v("Director's Comments")]), _vm._v(" "), _c('div', {
      staticClass: "submit-feedback"
    }, [_c('div', {
      staticClass: "stack",
      staticStyle: {
        "flex-grow": "4"
      }
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (project.feedbackComments),
        expression: "project.feedbackComments"
      }],
      staticClass: "form-control",
      domProps: {
        "value": (project.feedbackComments)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          project.feedbackComments = $event.target.value
        }
      }
    }), _vm._v(" "), ($index == _vm.student.final_projects.length - 1) ? _c('div', [(_vm.getStatus(project) == 'feedback_required') ? _c('label', [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": project.ignores == 1 || project.ignores == 3
      },
      on: {
        "change": function($event) {
          _vm.ignoreFeedback(project)
        }
      }
    }), _vm._v("\n                                            Ignore in Feedback Count\n                                        ")]) : _vm._e(), _vm._v(" "), (!project.cloudinaryIds && _vm.getStatus(project) == 'passed') ? _c('label', {
      staticStyle: {
        "margin-left": "2rem"
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": project.ignores == 2 || project.ignores == 3
      },
      on: {
        "change": function($event) {
          _vm.ignoreCloud(project)
        }
      }
    }), _vm._v("\n                                            Ignore in Cloudinary Count\n                                        ")]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "stack"
    }, [_c('label', {
      staticClass: "upload-feedback",
      attrs: {
        "for": "upload-feedback"
      }
    }, [_vm._v("\n                                        Place Feedback Video (MP4)\n                                        "), _c('input', {
      ref: "feedbackVideo",
      refInFor: true,
      attrs: {
        "type": "file",
        "id": "upload-feedback",
        "accept": "video/mp4"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "stack start"
    }, [_c('label', [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "passed",
        "disabled": _vm.disablePassCheckboxes
      },
      domProps: {
        "checked": !project.passed
      },
      on: {
        "change": function($event) {
          project.passed = false
        }
      }
    }), _vm._v("\n                                            Fixes Required\n                                        ")]), _vm._v(" "), _c('label', [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": "passed",
        "disabled": _vm.disablePassCheckboxes
      },
      domProps: {
        "checked": project.passed
      },
      on: {
        "change": function($event) {
          project.passed = true
        }
      }
    }), _vm._v("\n                                            Mark as Passed\n                                        ")])])]), _vm._v(" "), _c('div', {
      staticClass: "stack"
    }, [_c('button', {
      staticClass: "btn btn-success btn-blue",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.createFeedback(project.id)
        }
      }
    }, [_vm._v("Submit Feedback")]), _vm._v(" "), (_vm.inCloud(project) && (_vm.isLatestProject($index) || !_vm.inCloud(_vm.student.final_projects[$index + 1]))) ? _c('button', {
      staticClass: "btn btn-success btn-blue"
    }, [_c('a', {
      attrs: {
        "target": "_blank",
        "href": _vm.searchUrl(project.cloudinaryIds)
      }
    }, [_vm._v("\n                                            View in Cloudinary\n                                        ")])]) : ($index == _vm.student.final_projects.length - 1) ? _c('button', {
      staticClass: "btn btn-success btn-blue",
      attrs: {
        "disabled": _vm.uploadingToCloudinary
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.sendToCloudinary()
        }
      }
    }, [_vm._v("\n                                        Upload Project to Cloudinary\n                                    ")]) : _vm._e()])])], 2) : _vm._e()])
  })) : _vm._e()]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying === true),
      expression: "feedbackPlaying===true"
    }],
    staticClass: "feedback-lightbox",
    on: {
      "click": function($event) {
        _vm.stopFeedback()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-remove"
  }), _vm._v(" "), _c('div', {
    staticClass: "video-wrapper",
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('video-player', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.feedbackPlaying),
      expression: "feedbackPlaying"
    }],
    ref: "videoPlayer",
    attrs: {
      "options": _vm.playerOptions
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Course")]), _vm._v(" "), _c('th', [_vm._v("Exercise")]), _vm._v(" "), _c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Self-Assessment")]), _vm._v(" "), _c('th', [_vm._v("Comments")]), _vm._v(" "), _c('th', [_vm._v("Files")]), _vm._v(" "), _c('th', [_vm._v("Submitted On")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Course")]), _vm._v(" "), _c('th', [_vm._v("Assignment")]), _vm._v(" "), _c('th', [_vm._v("Week")]), _vm._v(" "), _c('th', [_vm._v("Submitted On")]), _vm._v(" "), _c('th', [_vm._v("Grade")]), _vm._v(" "), _c('th', [_vm._v("Submission")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('h4', {
    staticClass: "bold"
  }, [_vm._v("Additional Videos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f038e81!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Student.vue
// module id = 2029
// module chunks = 2